export default "__VITE_ASSET__f7d437f5__"